import { am5, am5xy } from '@local/finsera-core/src/libs';

export const createAxes = ({
  root,
  chart,
  minLimit,
  maxLimit,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  minLimit: number;
  maxLimit: number;
}) => {
  const xRenderer = am5xy.AxisRendererX.new(root, {
    minGridDistance: 60,
  });

  const xAxis = chart.xAxes.push(
    am5xy.ValueAxis.new(root, {
      renderer: xRenderer,
      extraMin: 0.004,
      extraMax: 0.002,
      tooltip: am5.Tooltip.new(root, {}),
      strictMinMax: true,
    })
  );

  xAxis.get('renderer').labels.template.setAll({
    fontSize: 11,
    textAlign: 'center',
  });

  xRenderer.grid.template.setAll({
    location: 1,
  });

  const yAxis = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      max: maxLimit,
      min: minLimit,
      tooltip: undefined,
      renderer: am5xy.AxisRendererY.new(root, {
        tooltip: null,
        minGridDistance: 40,
      }),
    })
  );

  yAxis.get('renderer').set('tooltip', null);
  yAxis.get('renderer').labels.template.setAll({
    fontSize: 11,
  });

  return { xAxis, yAxis };
};
